<template>
  <div>
    <div class="flex items-center justify-between mt-4 table-header-row">
      <slot name="header"></slot>
      <div class="flex items-center justify-start mr-4">
        <span>{{ from }}</span>
        <img 
          src="@/assets/orderTest/order-page/order-test-panel/menu-switch-dialog/arrow_right_white_20px.svg" 
          class="ml-5"
        >
        <span class="ml-5">{{ to }}</span>
      </div>
    </div>
    <div 
      v-for="row in data" 
      :key="row.id"
      class="flex items-center justify-between table-data-row"
    >
      <div class="ml-2.5 w-1/2">{{ row.name }}</div>
      <div class="flex items-center justify-end mr-6">
        <div class="from-price-text mr-12">
          {{ currency.symbol + row.fromPrice }}
        </div>
        <img 
          src="@/assets/orderTest/order-page/order-test-panel/menu-switch-dialog/arrow_right_black_20px.svg" 
          class="mr-8"
        >
        <div class="to-price-text">
          {{ row.toPrice }}
        </div>   
      </div>   
    </div> 
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    from: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(["currency"])
  }
}
</script>

<style scoped>
.table-header-row {
  height: 30px;
  background: #20A8C3;
  border: 1px solid #20A8C3;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4004px;
  color: #FFFFFF;
}

.table-data-row {
  min-height: 30px;
  background: #F8FAFB;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.87);
}

.from-price-text {
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.4004px;
  text-decoration-line: line-through;
  color: #767676;
}

.to-price-text {
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.4004px;
}
</style>